import ErrorMessage from "components/ErrorMessage/ErrorMessage"
import moment from "moment"
import custodiaIcon from "../assets/icons/custodia.png"
import devolvidoIcon from "../assets/icons/devolvido.png"
import encaminhadoIcon from "../assets/icons/encaminhado.png"
import postadoIcon from "../assets/icons/postado.png"
import saiuEntregaIcon from "../assets/icons/saiu_entrega.png"
import entregueIcon from "../assets/icons/entregue.png"
import updateRegistrationIcon from "../assets/icons/update_registration.png"
import naoEntregueIcon from "../assets/icons/nao_entregue.png"
import fabricadoIcon from "../assets/icons/factory.png"
import {
  faForward,
  faBusinessTime,
  faRetweet,
  faClipboardCheck,
  faTruck,
  faPaperPlane,
  faTimesCircle,
  faIndustry,
  faCheckCircle,
  faUndo,
  faHourglassHalf,
  faAddressCard,
  faShareSquare,
  faBan,
  faTrash,
  faFrown,
  faExclamation,
  faMailBulk,
} from "@fortawesome/free-solid-svg-icons"

export const objectToQueryString = obj => {
  let query = []
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      let value = obj[key]
      if (value instanceof Date) value = moment(value).format("YYYY-MM-DD")
      query.push(`${key}=${value}`)
    }
  }
  return `?${query.join("&")}`
}

export const formatDate = (dateString, format) => {
  return moment(dateString, "YYYY-MM-DD HH:mm:ss").format(
    format || "DD/MM/YYYY"
  )
}

export const getOrderLastStatus = order => {
  if (!order?.status || order?.status.length === 0) return "Não processado"
  const currentStatus = order?.status[order?.status.length - 1]
  if (currentStatus?.status) return currentStatus.status.name
  return currentStatus.externalEventName
}

export const getOrderLastStatusDate = (order, format = "DD/MM/YYYY HH:mm") => {
  if (!order?.status || order?.status.length === 0) return "-"
  const currentStatus = order?.status[order?.status.length - 1]
  // const dateFormat =
  //   moment(currentStatus.occurredAt?.split("T")[0]).format("DD/MM/YYYY") +
  //   " " +
  //   moment(new Date(currentStatus.occurredAt)).format("HH:mm")
  const dateFormat = moment(currentStatus.occurredAt).format("DD/MM/YYYY HH:mm")
  return dateFormat
}

export const formatPhoneNumber = number => {
  if (number == null) return ""
  if (typeof number !== "string") number = String(number)
  if (number.length > 9)
    return number.replace(/(\d{2})(\d{4,5})(\d{4})/, "($1) $2-$3")
  return number.replace(/(\d{4,5})(\d{4})/, "$1-$2")
}

export const onRequestError = (error, setAlert) => {
  const { response, message } = error
  if (response) {
    setAlert({
      message: response.data.errors.map((e, i) => (
        <ErrorMessage e={e} key={`err-${i}`} />
      )),
      type: "danger",
    })
  } else {
    setAlert({
      message,
      type: "danger",
    })
  }
}

export const getOrderSteps = (rightPath, orderPath) => {
  const statusMapper = p => {
    const statusId = p.status?.id || p.id
    let icon
    switch (Number(statusId)) {
      case 12:
        icon = custodiaIcon
        break
      case 7:
        icon = devolvidoIcon
        break
      case 2:
        icon = postadoIcon
        break
      case 3:
        icon = encaminhadoIcon
        break
      case 5:
        icon = saiuEntregaIcon
        break
      case 6:
        icon = entregueIcon
        break
      case 10:
        icon = updateRegistrationIcon
        break
      case 15:
        icon = naoEntregueIcon
        break
      case 25:
        icon = fabricadoIcon
        break
      default:
        icon = encaminhadoIcon
        break
    }
    if (p.status)
      return {
        title: (
          <div>
            {p.status.name}
            <br />
            {p.occurredAt && <small>{formatDate(p.occurredAt)}</small>}
          </div>
        ),
        date: p.occurredAt,
        icon: icon,
      }
    return {
      title: (
        <div>
          {p.externalEventName || p.name}
          <br />
          {p.occurredAt && <small>{formatDate(p.occurredAt)}</small>}
        </div>
      ),
      date: p.occurredAt,
      icon: icon,
    }
  }
  if (!orderPath?.length) {
    return {
      steps: rightPath
        .filter(p => p.status?.id !== undefined)
        .map(statusMapper),
      active: 0,
    }
  }
  const mapppedRightPathStatusIds = rightPath.map(p => p.id)
  const mappedOrderPathStatusIds = orderPath.map(p => p.statusId)
  const lastOrderStatusKnownId = mappedOrderPathStatusIds.pop()
  const indexOfRightPath = mapppedRightPathStatusIds.indexOf(
    lastOrderStatusKnownId
  )
  let steps = []

  let listOfPathsNotConcludedYet = null
  if (indexOfRightPath !== -1) {
    steps = orderPath.filter(p => p.statusId !== null).map(statusMapper)
    const nextPathIndex = indexOfRightPath + 1
    listOfPathsNotConcludedYet = rightPath.slice(nextPathIndex)
    steps = steps.concat(listOfPathsNotConcludedYet.map(statusMapper))
  } else {
    steps = orderPath
      .slice(0, indexOfRightPath)
      .filter(p => p.statusId !== null)
      .map(statusMapper)
    const unexpectedOrderSteps = orderPath
      .slice(indexOfRightPath)
      .map(statusMapper)
    steps = steps.concat(unexpectedOrderSteps)
  }
  return {
    steps,
    active:
      lastOrderStatusKnownId &&
      indexOfRightPath < steps.length &&
      indexOfRightPath !== -1 &&
      steps.length - 1 < rightPath.length
        ? indexOfRightPath < listOfPathsNotConcludedYet.length
          ? indexOfRightPath
          : indexOfRightPath - listOfPathsNotConcludedYet.length
        : steps.length - 1,
  }
}

export const getIcon = id => {
  const icons = {
    16: faAddressCard,
    17: faAddressCard,
    2: faPaperPlane,
    3: faShareSquare,
    5: faTruck,
    6: faMailBulk,
    11: faTrash,
    4: faTrash,
    7: faUndo,
    9: faTrash,
    13: faMailBulk,
    15: faFrown,
    24: faBan,
    8: faBusinessTime,
    12: faBusinessTime,
    14: faRetweet,
  }
  return icons[id] || faExclamation
}

export const formatCurrency = value => {
  return Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value)
}

export const formatarString = (str, size = 20) => {
  return str.length > size ? str.slice(0, size).trim() + "..." : str
}

export const getHexColorByClassName = className => {
  var newValue = className.replace(" ", "")
  if (newValue.indexOf(",") === -1) {
    var color = getComputedStyle(document.documentElement).getPropertyValue(
      newValue
    )

    if (color.indexOf("#") !== -1) color = color.replace(" ", "")
    if (color) return color
    else return newValue
  } else {
    var val = className.split(",")
    if (val.length === 2) {
      var rgbaColor = getComputedStyle(
        document.documentElement
      ).getPropertyValue(val[0])
      rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")"
      return rgbaColor
    } else {
      return newValue
    }
  }
}
